import React from 'react';
import { mergeProps } from 'next-merge-props';

import { IPage, ITextOnlyHeroFields } from '../../../types/contentful';

import { getServerSideSubscriptionProps } from '../../modules/subscriptions/getServerSideSubscriptionProps';
import { getServerSideCookieProps } from '../../modules/cookies/getServerSideCookieProps';

import { PageProps } from '../../context/PageData';

import { Body } from '../../components/Body';
import { SectionWithCollapsibles } from '../../components/SectionWithCollapsibles';
import { VariationContainer } from '../../components/VariationContainer';
import { OptionSelect } from '../../components/OptionSelect';
import { BodyCopy } from '../../components/BodyCopy';
import { TextOnlyHero } from '../../components/TextOnlyHero';

interface SubscriptionsPage extends PageProps {
  step?: string;
}

export default function PurchaseSubscriptions({
  pageData,
  query
}: SubscriptionsPage) {
  const { fields } = (pageData as IPage) ?? {};
  const { pageBlocks, heroBlock } = fields ?? {};

  return (
    <Body {...fields} query={query} bgColor="#F3F3F3">
      <TextOnlyHero
        {...(heroBlock?.fields as ITextOnlyHeroFields)}
        yMarginTopOverride={{ 0: '[96px]', desktop: '[64px]' }}
      />

      {pageBlocks?.map(({ sys, fields: blocks }: any) => (
        <section key={sys?.id} data-cfid={sys?.id} data-testid="page-block">
          {(() => {
            switch (sys?.contentType?.sys?.id) {
              case 'bodyCopy':
                return <BodyCopy {...blocks} />;

              case 'optionSelect':
                return <OptionSelect {...blocks} />;

              case 'sectionWithCollapsibles':
                return <SectionWithCollapsibles {...blocks} fullWidthHeader />;

              case 'variationContainer':
                return <VariationContainer {...fields} sysId={sys?.id} />;

              default:
                return null;
            }
          })()}
        </section>
      ))}
    </Body>
  );
}

export const getServerSideProps = mergeProps([
  getServerSideSubscriptionProps,
  getServerSideCookieProps
]);
